import { useLazyQuery } from '@apollo/client/react';
import { useEffect } from 'react';

import { GetUberOrganizationSettingOnEditDocument } from '~/graphql/generated/graphql';
import { getMe } from '~/graphql/utility';

export const useFetchUberOrganizationSetting = () => {
  const [getUberOrganizationSetting, { data, loading, called }] = useLazyQuery(
    GetUberOrganizationSettingOnEditDocument,
    {
      fetchPolicy: 'cache-and-network',
    },
  );

  const organization = data ? getMe(data)?.organization : null;
  const uberSettingEnable = organization?.uberOrganizationSetting?.enable || false;

  useEffect(() => {
    getUberOrganizationSetting();
  }, [getUberOrganizationSetting]);

  return {
    uberSettingEnable,
    loading: loading || !called,
  };
};
